<template>
  <div class="collection-showcase">
    <div class="collection-showcase__column" data-scroll-scale="1">
      <div
        class="collection-showcase__bottle-wrapper"
        data-in-out
        data-in-out-animation="slide"
        data-in-delay="0.4"
      >
        <ShowcaseBottle
          :color="'black'"
          :name="'<div class=\'stagger\'>Prestige</div><div class=\'stagger\'>1821</div>'"
          :to="'/collection/prestige-1821'"
          :image="'/static/bottles/prestige-1821/preview.jpg'"
          :imageHover="'/static/bottles/prestige-1821/preview_hover.jpg'"
        />
      </div>
      <div
        class="collection-showcase__bottle-wrapper"
        data-in-out
        data-in-out-animation="slide"
        data-in-delay="0.4"
      >
        <ShowcaseBottle
          :color="'grey'"
          :name="'<div class=\'stagger\'>Black</div><div class=\'stagger\'>Cuvée</div>'"
          :to="'/collection/black-cuvee'"
          :image="'/static/bottles/black-edition/preview.jpg'"
          :imageHover="'/static/bottles/black-edition/preview_hover.jpg'"
        />
      </div>
      <div
        class="collection-showcase__bottle-wrapper"
        data-in-out
        data-in-out-animation="slide"
        data-in-delay="0.4"
      >
        <ShowcaseBottle
          :color="'grey'"
          :name="'<div class=\'stagger\'>Cuvée</div><div class=\'stagger\'>1821</div>'"
          :to="'/collection/cuvee-1821'"
          :image="'/static/bottles/cuvee-1821/preview.jpg'"
          :imageHover="'/static/bottles/cuvee-1821/preview_hover.jpg'"
        />
      </div>
    </div>
    <div class="collection-showcase__column" data-scroll-scale="1.2">
      <div
        class="collection-showcase__bottle-wrapper"
        data-in-out
        data-in-out-animation="slide"
        data-in-delay="0.4"
      >
        <ShowcaseBottle
          :color="'black'"
          :name="'<div class=\'stagger\'>Special</div><div class=\'stagger\'>Cuvée</div><div class=\'stagger\'>Millesimato</div>'"
          :to="'/collection/special-cuvee-millesimato'"
          :image="'/static/bottles/special-cuvee/preview.jpg'"
          :imageHover="'/static/bottles/special-cuvee/preview_hover.jpg'"
        />
      </div>
      <div
        class="collection-showcase__bottle-wrapper"
        data-in-out
        data-in-out-animation="slide"
        data-in-delay="0.4"
      >
        <ShowcaseBottle
          :color="'grey'"
          :name="'<div class=\'stagger\'>Grey</div><div class=\'stagger\'>Cuvée</div>'"
          :to="'/collection/grey-cuvee'"
          :image="'/static/bottles/grey-edition/preview.jpg'"
          :imageHover="'/static/bottles/grey-edition/preview_hover.jpg'"
        />
      </div>
      <div
        class="collection-showcase__bottle-wrapper"
        data-in-out
        data-in-out-animation="slide"
        data-in-delay="0.4"
      >
        <!-- <ShowcaseBottle
          :color="'black'"
          :name="'<div class=\'stagger\'>Spumante</div><div class=\'stagger\'>Brut</div>'"
          :to="'/collection/spumente-brut'"
          :image="'/static/bottles/spumante-brut/preview.jpg'"
          :imageHover="'/static/bottles/spumante-brut/preview_hover.jpg'"
        /> -->
      </div>
    </div>
    <div class="collection-showcase__column" data-scroll-scale="1.1">
      <div
        class="collection-showcase__bottle-wrapper"
        data-in-out
        data-in-out-animation="slide"
        data-in-delay="0.4"
      >
        <ShowcaseBottle
          :color="'white'"
          :name="'<div class=\'stagger\'>Platinum</div><div class=\'stagger\'>Label</div>'"
          :to="'/collection/platinum-label-en'"
          :image="'/static/bottles/spumante-brut/preview.jpg'"
          :imageHover="'/static/bottles/spumante-brut/preview_hover.jpg'"
        />
      </div>
      <div
        class="collection-showcase__bottle-wrapper"
        data-in-out
        data-in-out-animation="slide"
        data-in-delay="0.4"
      >
        <ShowcaseBottle
          :color="'white'"
          :name="'<div class=\'stagger\'>White</div><div class=\'stagger\'>Cuvée</div>'"
          :to="'/collection/white-cuvee'"
          :image="'/static/bottles/white-edition/preview.jpg'"
          :imageHover="'/static/bottles/white-edition/preview_hover.jpg'"
        />
      </div>
      <div
        class="collection-showcase__bottle-wrapper"
        data-in-out
        data-in-out-animation="slide"
        data-in-delay="0.4"
      >
        <!-- <ShowcaseBottle :color="'white'" :name="''" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import engine from '@/scripts/engine';
import scroll from '@/scripts/scroll';
import ShowcaseBottle from '@/components/contents/ShowcaseBottle.vue';
import { isMobile } from '../../scripts/utils';

export default {
  name: 'CollectionShowcase',

  components: {
    ShowcaseBottle,
  },

  mounted() {
    engine.add(this.scroll, 'showcase-scroll');
    this.$nextTick(() => scroll.setBoundries(this.$el));
  },

  methods: {
    scroll() {
      scroll.checkIsScrolled();
      if (!isMobile()) {
        const columns = Array.from(this.$el.querySelectorAll('.collection-showcase__column'));
        columns.forEach((column) => {
          column.style.transform = `translateY(-${scroll.ref.amount.y * column.dataset.scrollScale}px)`;
        });
      } else {
        const columns = Array.from(this.$el.querySelectorAll('.collection-showcase__column'));
        columns.forEach((column) => {
          column.style.transform = `translateY(-${scroll.ref.amount.y}px)`;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.collection-showcase {
  padding-top: 80vh;
  padding-top: calc(var(--vh, 1vh) * 80);
  padding-left: calc((100vw / 32) * 4);
  padding-right: calc((100vw / 32) * 4);

  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  @include mq($until: ipadL) {
    padding-top: calc(var(--vh, 1vh) * 60);
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }

  &__column {
    flex-basis: 33.33%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include mq($until: ipadL) {
      flex-basis: 100%;
      flex-wrap: wrap;
    }
  }

  &__bottle-wrapper {
    @include mq($until: ipadL) {
      .showcase-bottle {
        width: calc(219px * var(--rw));
        height: calc(780px * var(--rw));
      }
    }
  }
}
</style>
